<div class="flex-col gap-y-2 m-0 bg-purple-50 p-4">
  <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
  <app-blanket>
    <mat-tab-group #tabGroup [selectedIndex]="selectedTabIndex">
      <!-- Notation Form Tab -->
      <mat-tab label="Report Form">
        <div class="flex">
          <!-- First part: Small calendar -->
          <div class="w-1/3 p-4 bg-gray-100">
            <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateChange($event)"></mat-calendar>
          </div>

          <!-- Second part: Daily Report -->
          <div class="w-2/3 p-4">
            <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="reportDatePicker" formControlName="date">
                <mat-datepicker-toggle matSuffix [for]="reportDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #reportDatePicker></mat-datepicker>
              </mat-form-field>

              <div>
                <label class="pb-2">Report Content:</label>
                <app-rich-text-editor [content]="content"  (contentChanged)="onEditorContentChanged($event)"></app-rich-text-editor>
              </div>

              <div class="flex items-top gap-x-2 mt-4">
                <mat-form-field class="flex-1 m" appearance="outline">
                  <mat-label>References</mat-label>
                  <mat-chip-list class="py-4" #referenceList>
                    <mat-chip *ngFor="let ref of references || []" (removed)="removeReference(ref)">
                      {{ ref.name }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <mat-chip disabled *ngIf="(references?.length ?? 0) === 0">No references added</mat-chip>
                  </mat-chip-list>
                </mat-form-field>
                <button color="primary" mat-icon-button (click)="openReferencePopup()">
                  <mat-icon>add</mat-icon>
                </button>
              </div>

              <div class="flex justify-end">
                <button mat-raised-button class="border rounded-pill" color="primary" type="submit" [disabled]="isContentEmpty || isLoading">
                  <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
                  <span *ngIf="!isLoading">Submit Report</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Reference Popup -->
        <ng-template style="position: relative;" #referencePopup>
          <button class="absolute top-4 right-4" (click)="closeReferencePopup()">
            <mat-icon>close</mat-icon>
          </button>
          <div class="flex flex-col h-100">
            <h3 class="p-4 m-0 border-b">Select References</h3>
            <div class="flex-grow flex overflow-y-scroll p-4">
              <div class="w-1/2 p-2">
                <h2 class="m-0">Tasks</h2>
                <mat-list class="flex flex-col gap-y-2">
                  <mat-list-item class="hover:bg-gray-200 rounded-pill cursor-pointer" *ngFor="let task of tasks" (click)="addReference(task, 'task')">
                    {{ task.name }}
                    <mat-icon class="add-icon">add</mat-icon>
                  </mat-list-item>
                </mat-list>
              </div>
              <div class="w-1/2 p-2">
                <h2>Projects</h2>
                <mat-list class="flex flex-col gap-y-2">
                  <mat-list-item class="hover:bg-gray-200 rounded-pill cursor-pointer" *ngFor="let project of projects" (click)="addReference({ id: project.id.toString(), name: project.name }, 'project')">
                    {{ project.name }}
                    <mat-icon class="add-icon">add</mat-icon>
                  </mat-list-item>
                </mat-list>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <!-- History Tab -->
      <mat-tab label="History">
        <div class="flex">
          <!-- First part: Small calendar -->
          <div class="w-1/3 p-4 bg-gray-100">
            <mat-slide-toggle color="primary" [(ngModel)]="showAllReports" (change)="onToggleChange($event)">Show All Reports</mat-slide-toggle>
            <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateChange($event)"></mat-calendar>
          </div>

          <!-- Second part: Previous Reports -->
          <div class="w-2/3 p-4">
            <h2>Previous Reports</h2>

            <div *ngFor="let report of filteredReports" class="p-4 pb-2  mb-4 border border-gray-100 rounded-lg bg-gray-50 ">
              <time class="text-lg font-semibold text-gray-900 ">
                {{ report.newDateFormat }}
              </time>
              <ol class="mt-3 divide-y divide-gray-200 p-0">
                <li class="list-none p-0">
                  <div class="items-start block p-3 sm:flex ">
                    <div class="pe-2">
                      <mat-icon class="w-8 h-8 text-gray-400 " aria-hidden="true">person</mat-icon>
                    </div>
                    <div class="text-gray-600">
                      <div class="text-base font-normal">
                        <span class="font-medium text-gray-900 ">{{ report.userName }}</span>
                        {{ report.action }}
                        <span class="font-medium text-gray-900 ">{{ report.target }}</span>
                      </div>
                      <div class="html-content-reset text-gray-600" [innerHTML]="report.content"></div>
                      <span class="inline-flex items-center text-xs font-normal text-gray-500 ">
                    {{ report.visibility }}
                  </span>
                      <!-- Display References -->
                      <div class="flex items-top gap-x-2 mt-4">
                        <mat-chip-list class="py-4" *ngIf="(report.references?.length ?? 0) > 0">
                          <mat-chip *ngFor="let ref of report.references || []">
                            <a [routerLink]="ref.type === 'task' ? ['/task', ref.id] : ['/project', ref.id]">
                              {{ ref.name }}
                            </a>
                          </mat-chip>
                        </mat-chip-list>
                        <mat-chip disabled *ngIf="(report.references?.length ?? 0) === 0">No references added</mat-chip>
                      </div>
                      <!-- End of Display References -->
                    </div>
                  </div>
                  <div class="flex items-end border-t justify-end gap-2 pt-2">
                    <button mat-icon-button (click)="editReport(report)" [disabled]="!isToday(report.date)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deleteReport(report)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </app-blanket>
</div>
